export const REAL_JOB_PHOTOS = [
  {
    src: "/images/hero-porsche.webp",
    alt: "BM Towing flatbed loading a white Porsche at the Bellevue dealership at night",
    title: "Luxury Flatbed — Bellevue Porsche",
    description:
      "Late-night dealer flatbed transport of a Porsche at Bellevue's Porsche dealership. Careful loading, strapped down, delivered safely.",
    tags: ["Flatbed", "Porsche", "Bellevue", "Dealership"],
  },
  {
    src: "/images/hero-porsche-2.webp",
    alt: "BM Towing branded flatbed with a Porsche on the deck at a Bellevue dealership",
    title: "Signature Porsche Move — Bellevue",
    description:
      "BM Towing signature transport — Porsche safely on the deck of our flatbed after a Bellevue dealer call.",
    tags: ["Flatbed", "Porsche", "Bellevue", "Signature"],
  },
  {
    src: "/images/job-tire.webp",
    alt: "Severely shredded rear tire needing roadside tire-change assistance",
    title: "Blown Tire — Roadside Call",
    description:
      "Catastrophic tire blowout — customer stranded, called us for a roadside tire change. Swapped and back on the road.",
    tags: ["Roadside", "Tire Change", "Night Call"],
  },
  {
    src: "/images/job-4.webp",
    alt: "BM Towing recovering a Mini Cooper from a roadside ditch on a wet day",
    title: "Ditch Recovery — Kirkland Area",
    description:
      "Mini Cooper off the shoulder into a ditch. Winched out, cleaned up, loaded, and delivered.",
    tags: ["Recovery", "Winch-Out", "Kirkland"],
  },
  {
    src: "/images/job-3.webp",
    alt: "BM Towing flatbed hauling a large tool cabinet strapped down",
    title: "Equipment Haul — Eastside",
    description:
      "Heavy toolbox transport strapped and secured on the flatbed. Not just cars — we move equipment too.",
    tags: ["Flatbed", "Equipment", "Commercial"],
  },
];
